import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Pipe({
  name: 'highlightWord',
  standalone: true,
})
export class HighlightWordPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, word: string): SafeHtml {
    if (!text || !word) {
      return text
    }

    try {
      // Escape special characters for regex
      const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

      // Create regex pattern that matches the whole word with word boundaries
      const pattern = `\\b${escapedWord}\\b`

      const regex = new RegExp(pattern, 'gi')

      // Replace matching words with underlined span
      const highlighted = text.replace(regex, match => {
        return `<span style="text-decoration: underline;">${match}</span>`
      })

      return this.sanitizer.bypassSecurityTrustHtml(highlighted)
    } catch (error) {
      console.error('Error in HighlightWordPipe:', error)
      return text
    }
  }
}
